var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNordPassLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6134 70C2.82435 63.352 0 55.1722 0 46.3273C0 24.0552 17.9086 6 40 6C62.0914 6 80 24.0552 80 46.3273C80 55.1721 77.1757 63.3518 72.3867 69.9999L53.1747 38.5466L51.3195 41.7046L53.2018 50.4877L40 27.7147L31.8334 41.6161L33.7346 50.4877L26.8147 38.5646L7.6134 70Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordPassLight);
export default __webpack_public_path__ + "static/media/NordPassLight.8f45ee6c590cc9eede49d718f726942f.svg";
export { ForwardRef as ReactComponent };